import React from "react";
import { useLang, t } from "@/context/LangContext";

const Footer = () => {
  const { lang } = useLang();
  return (
    <footer className="border-t border-white/10 mt-24 py-12 px-6 lg:px-10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-3">
            <img src="/assets/logo.jpg" alt="Pintar Investasi" className="w-9 h-9 rounded-md object-cover" />
            <div className="leading-tight">
              <div className="font-display font-black text-lg tracking-tight">PINTAR</div>
              <div className="font-display text-[10px] text-white/50 tracking-[0.15em] uppercase">Investasi</div>
            </div>
          </div>
          <p className="text-sm text-white/60 max-w-xs">
            {t(lang, "Platform edukasi investasi dan analisa saham IDX & US.", "Investment education and stock analysis for IDX & US markets.")}
          </p>
        </div>
        <div>
          <div className="overline text-white/40 mb-3">{t(lang, "Data", "Data")}</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>Alpha Vantage API</li>
            <li>Curated Fundamentals</li>
            <li>{t(lang, "Update Harian", "Daily Updates")}</li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/40 mb-3">{t(lang, "Fitur", "Features")}</div>
          <ul className="space-y-2 text-sm text-white/70">
            <li>{t(lang, "Kalkulator Nilai Wajar", "Fair Value Calculator")}</li>
            <li>AI Analyst (Claude 4.5)</li>
            <li>{t(lang, "IPO Kalender", "IPO Calendar")}</li>
          </ul>
        </div>
        <div>
          <div className="overline text-white/40 mb-3">Disclaimer</div>
          <p className="text-xs text-white/50 leading-relaxed">
            {t(lang,
              "Konten ini hanya untuk edukasi. Bukan saran keuangan. Lakukan riset sendiri sebelum berinvestasi.",
              "Content is for education only. Not financial advice. Do your own research before investing.")}
          </p>
        </div>
      </div>
      <div className="max-w-[1400px] mx-auto mt-10 pt-6 border-t border-white/5 text-xs text-white/40 font-mono">
        © 2026 PINTAR INVESTASI. All rights reserved.
      </div>
    </footer>
  );
};

export default Footer;
